import type { JsonSchemaNode } from "@nmblr-platform-flow/schema";
import { humanize } from "../../../lib/humanize.js";

interface Props {
	name: string;
	schema: JsonSchemaNode;
	value: unknown;
	onChange: (value: unknown) => void;
	required?: boolean;
}

export function BooleanToggle({ name, schema, value, onChange, required }: Props) {
	const id = `field-${name}`;
	const checked =
		typeof value === "boolean" ? value : ((schema.default as boolean | undefined) ?? false);
	return (
		<label className="mb-3 flex cursor-pointer items-center gap-3" htmlFor={id}>
			<input
				id={id}
				type="checkbox"
				checked={checked}
				onChange={(e) => onChange(e.target.checked)}
				className="h-4 w-4 rounded border-border bg-canvas accent-accent"
			/>
			<span className="text-xs text-text-muted">
				{humanize(name)}
				{required && <span className="ml-1 text-error">*</span>}
			</span>
			{schema.description && (
				<span className="text-xs text-text-muted">— {schema.description}</span>
			)}
		</label>
	);
}
